import "./FlightDeck.module.css";
import Header from "@/reusable_sections/Header";
import EstablishContact from "./sections/EstablishContact";
import OurHangarLocation from "./sections/OurHangarLocation";
import Footer from "@/reusable_sections/Footer";
export default function FlightDeckPage() {
  return <div>
      <Header />
      <EstablishContact />
      <OurHangarLocation />
      <Footer />
    </div>;
}